module.exports = __webpack_public_path__ + "static/media/4.3c95c620.jpg";